<template>
  <div style="display: none;">
    <slot v-if="ready"></slot>
  </div>
</template>

<script>
import L from 'leaflet'
import { findRealParent, propsBinder } from 'vue2-leaflet'

import HeatmapOverlay from 'leaflet-heatmap'

const props = {
  latLng: {
    type: Object,
    default: () => {},
    custom: false
  },
  visible: {
    type: Boolean,
    custom: true,
    default: true
  }
}
export default {
  name: 'LHeatmap',
  props,
  data () {
    return {
      ready: false
    }
  },
  mounted () {
    const config = {
      radius: 8,
      maxOpacity: 0.9,
      scaleRadius: true,
      useLocalExtrema: false,
      latField: 'lat',
      lngField: 'lng',
      valueField: 'value'
    }
    /* eslint no-undef: "off" */
    this.mapObject = new HeatmapOverlay(config)
    L.DomEvent.on(this.mapObject, this.$listeners)
    propsBinder(this, this.mapObject, props)
    this.ready = true
    this.parentContainer = findRealParent(this.$parent)
    this.parentContainer.addLayer(this, !this.visible)
    this.mapObject.setData(this.latLng)
    this.mapObject._heatmap.configure({ gradient: this.latLng.gradient })
  },
  beforeDestroy () {
    this.parentContainer.removeLayer(this)
  },
  methods: {
    setVisible (newVal, oldVal) {
      if (newVal === oldVal) return
      if (newVal) {
        this.parentContainer.addLayer(this)
      } else {
        this.parentContainer.removeLayer(this)
      }
    }
  },
  watch: {
    latLng: function (val) {
      this.mapObject.setData(val)
      this.mapObject._heatmap.configure({ gradient: val.gradient })
    }
  }
}
</script>

<style>
</style>
